// Only translate shipped defaults and fixed choices from the previous library.
// Any other value is user-authored content and must remain verbatim.
const previousValues: Record<string, Record<string, Record<string, string>>> = {
  'premium-dark-splash': {
    botanical: { 'Không có': 'None' },
    campaignColor: { 'Cam nâu / hổ phách': 'Brown orange / amber' },
    accentColor: { 'Trắng': 'White' },
    waterColor: { 'Cam hổ phách trong suốt': 'Clear amber orange' },
    mood: { 'Cao cấp / tự nhiên / sang trọng / năng động / thanh khiết': 'Premium / natural / elegant / energetic / pure' },
  },
  'dynamic-ingredient-splash': {
    backgroundColor: { 'Nâu đỏ': 'Deep red brown' },
    accentLightColor: { 'Cam vàng': 'Golden orange' },
    energyStyle: { 'Tươi mát / mạnh mẽ / ngọt ngào / cao cấp / thiên nhiên': 'Fresh / bold / sweet / premium / natural' },
    waterEffectLevel: { 'Nhẹ': 'Light', 'Vừa': 'Medium', 'Mạnh': 'Strong' },
    ratio: { '2:3 dọc': 'Vertical 2:3', '4:5 dọc': 'Vertical 4:5', '9:16 dọc': 'Vertical 9:16' },
    negativeSpace: { 'Không cần khoảng trống đặt chữ': 'No space needed for text' },
    exclusions: { 'Người, chữ quảng cáo, slogan, logo phát sinh, watermark': 'People, advertising text, slogans, generated logos, watermarks' },
  },
  'natural-basket-lifestyle': {
    basketObjects: { 'Các nhánh nha đam tươi sạch, mát mắt; một chén thủy tinh chứa nha đam nạo trong suốt và tươi mát': 'Fresh, clean aloe vera sprigs; a glass bowl filled with clear, fresh shaved aloe vera' },
  },
  'bright-orange-platform': {
    backgroundColor: { 'Cam sáng / cam vàng': 'Bright orange / golden orange' },
    fruit: { 'Cam tươi': 'Fresh orange' },
  },
  'premium-fruit-beverage-hero': {
    backgroundColor: { 'Cam': 'Orange' },
    fruit: { 'Trái Cam': 'Orange' },
  },
  'frozen-coconut-strawberry': {
    backgroundColor: { 'Trắng lạnh pha hồng nhạt': 'Cool white with a soft pink tint' },
    fruit: { 'Dâu tây': 'Strawberry' },
  },
};

export function migratePromptDraftValue(templateId: string, fieldKey: string, value: string): string {
  const choices = previousValues[templateId]?.[fieldKey];
  return choices && Object.hasOwn(choices, value) ? choices[value] : value;
}
